<template>
    <div class="warehouse">
        <div class="table">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="id" label="ID" width="80" align="center"> </el-table-column>
                <el-table-column prop="title" label="标题" align="center"> </el-table-column>
                <el-table-column prop="sender_name" label="发货人姓名" align="center"> </el-table-column>
                <el-table-column prop="sender_cellphone" label="发货人手机号" align="center"> </el-table-column>
                <el-table-column prop="address" label="地址" align="center">
                    <template slot-scope="scope">
                        <el-tooltip :content="`${scope.row.province}${scope.row.city}${scope.row.district}${scope.row.address}`" placement="top" effect="light">
                            <span>{{ `${scope.row.province}${scope.row.city}${scope.row.district}${scope.row.address}` | strFmt }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="opt" align="center">
                    <template slot-scope="scope">
                        <div class="link">
                            <el-link type="primary" @click="edit(scope.row)">编辑</el-link>
                            <el-link type="primary" @click="deleteWarehouseFunc(scope.row.id)">删除</el-link>
                            <el-link type="primary" @click="detail(scope.row.id)">详情</el-link>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="create_time" label="创建时间" align="center"> </el-table-column>
                <el-table-column prop="update_time" label="更新时间" align="center"> </el-table-column> -->
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    data() {
        return {
            tableData: [],
            page: 1,
            size: 10,
            total: 0,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 10) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    mounted() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            getWarehouseList: "brand/getWarehouseList",
            deleteWarehouse: "brand/deleteWarehouse",
        }),
        detail(id){
            this.$emit("detail",id)
        },
        edit(id){
            this.$emit("edit",id)
        },
        deleteWarehouseFunc(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        token: this.getToken,
                        id: id,
                    };
                    this.deleteWarehouse(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList()
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        getList(tag) {
            let params = {
                merchantId:this.$getSessionStorage("userid"),
                page: this.page,
                size: this.size,
            };
            this.getWarehouseList(params).then(res=> {
                if (res.code == 10000) {
                    this.tableData = res.data;
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.warehouse {
    padding: 12px;
    .table {
        min-height: 550px;
    }
    .pagination {
        margin-top: 20px;
        float: right;
    }
    ::v-deep .el-table th.el-table__cell {
        background-color: #f4f4f4;
    }
    .link {
        a {
            margin: 0 8px;
        }
    }
}
</style>